import { Injectable } from '@angular/core';
import * as lscache from 'lscache';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageCacheServiceService {

  constructor() { }

  set (key: string, value: any, ttl: number = 1 /* 1 minute */) {
    lscache.set(key, value, ttl);
  }

  get (key: string):any {
    lscache.get(key);
  }
}
